import { makeStyles } from '@material-ui/core/styles'

import { COLORS, FONT_FAMILY, FONT_WEIGHT } from 'styles'

const useStyles = makeStyles(() => ({
  overflow: {
    overflow: 'visible',
  },
  dialogContent: {
    padding: '15px 30px',
    overflowY: 'auto',
    minHeight: 0,
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
  },
  title: {
    fontFamily: FONT_FAMILY,
    fontWeight: FONT_WEIGHT.semiBold,
    fontSize: '18px',
    color: COLORS.PRIMARY,
    lineHeight: '1.5em',
  },
  subtitle: {
    fontFamily: FONT_FAMILY,
    fontWeight: FONT_WEIGHT.semiBold,
    fontSize: '17px',
    color: COLORS.FONT,
    lineHeight: '1em',
  },
  closeButton: {
    color: COLORS.PRIMARY,
    padding: 4,
    marginLeft: 8,
    marginRight: -8,
  },
  titleAccessory: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginLeft: 'auto',
  },
  actions: {
    padding: '12px 24px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  actionsStart: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 'auto',
  },
  actionsGroup: {
    display: 'grid',
    gridAutoFlow: 'column',
    gridAutoColumns: '1fr',
    columnGap: 16,
  },
  actionButton: {
    minWidth: 0,
    paddingLeft: 32,
    paddingRight: 32,
    margin: 0,
    whiteSpace: 'nowrap',
  },
}))

export { useStyles }
